
namespace TabAurous.JobWork{

    @Serenity.Decorators.registerClass()
    export class JobWorkReturnGrid extends Serenity.EntityGrid<JobWorkReturnRow, any> {
        protected getColumnsKey() { return 'JobWork.JobWorkReturn'; }
        protected getDialogType() { return JobWorkReturnDialog; }
        protected getIdProperty() { return JobWorkReturnRow.idProperty; }
        protected getInsertPermission() { return JobWorkReturnRow.insertPermission; }
        protected getLocalTextPrefix() { return JobWorkReturnRow.localTextPrefix; }
        protected getService() { return JobWorkReturnService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container); 
        }

        protected addButtonClick() {
            
            let now = new Date();

            var voucherNo = FormatHelper.GetVoucherNo(43);

            this.editItem(<JobWorkReturnRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                TransDate: now.toDateString(),
                CompanyId: Q.Authorization.userDefinition.CompanyId,
                FinancialYearId: Q.Authorization.userDefinition.FinancialYearId,
                UserId: Q.Authorization.userDefinition.UserId,
                CurrencyId: Q.Authorization.userDefinition.CurrencyId,
                VoucherTypeId: 43,
                RoundOff: 0
                       
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 10;
            return opt;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}